import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import '../styles/lines.css';

const CollapseCodify = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b w-5/6">
      <button
        className="flex justify-between w-full p-4 text-lg xl:text-xl font-semibold items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="font-poppins">{title}</div>

        <div className="ml-auto flex items-center">
          {isOpen ? <Minus className="text-[#96226E] w-5 w-5 xl:w-8 xl:h-8" /> : <Plus className="hover:text-[#96226E] w-5 w-5 xl:w-8 xl:h-8" />}
        </div>
      </button>

      {isOpen && <div className="p-4 font-poppins text-[#201c31]">{children}</div>}
    </div>
  );
};

export default CollapseCodify;
